import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {To} from "react-router";
import {AppState} from "lib/redux/store";

interface ChoseCustomerState {
    to: To
    customer: string
}

const initialState: ChoseCustomerState = {
    to: "/",
    customer: ""
}

const {actions, reducer} = createSlice({
    name: "login",
    initialState: initialState,
    reducers: {
        setTo: (state, action: PayloadAction<To>) => {
            state.to = action.payload;
        },
        setCustomer: (state, action: PayloadAction<string>) => {
            state.customer = action.payload;
        },
        reset: (state) => {
            state.to = "/";
            state.customer = "";
        }
    }
});

function getChoseCustomerState(state: AppState): ChoseCustomerState {
    return state.choseCustomer;
}

const selectors = {
    to: (state: AppState) => getChoseCustomerState(state).to,
    customer: (state: AppState) => getChoseCustomerState(state).customer
}

export {actions as choseCustomerActions};
export {reducer as choseCustomerReducer};
export {selectors as choseCustomerSelectors};